var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('el-form-item',{attrs:{"label":_vm.label,"prop":_vm.name}},[_c('el-input',{ref:"input",attrs:{"clearable":""},on:{"input":function($event){return _vm.onInput(_vm.name, $event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }